module.exports = __webpack_public_path__ + "static/assets/899e39cd4f7b43c6c31b2e6469fafb9e.png";